/**
 * @file        find PixiJS node from react instance
 * @author      Icemic Jia <bingfeng.web@gmail.com>
 * @copyright   2017 Icemic Jia
 * @link        https://www.avgjs.org
 * @license     Apache License 2.0
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const PIXI = require('pixi.js');

export default function findPixiNode(ref) {
  const instance = ref._reactInternalInstance;
  const node = instance._renderedComponent.node || instance._mountImage;

  if (node) {
    return node;
  } else if (ref instanceof PIXI.DisplayObject) {
    return ref;
  }

  return null;
}



// WEBPACK FOOTER //
// ./src/components/findPixiNode.js